












































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VMoney } from 'v-money';
import FeeDiscount from '@/domain/contract/entity/fee-discount.interface';
import Rules from '@/shared/rules/rules';

@Component({
  directives: {
    money: VMoney,
  },
})
export default class FeeDiscountTableComponent extends Vue {
  @Prop({ type: String, required: true }) label!: string;

  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  @Prop({ type: Boolean, default: false }) selectionDisabled!: boolean;

  @Prop({ type: Array, default: true }) items!: Array<FeeDiscount>;

  @Prop({ type: String, required: true }) type!: string;

  @Prop({ type: Boolean, default: true }) limitMaximumPercent!: boolean;

  validationRules: Rules = new Rules();

  headers = [
    {
      text: '',
      value: 'selection',
      sortable: false,
    },
    {
      text: 'Cálculos de atuação',
      value: 'description',
      sortable: false,
    },
    {
      text: this.label,
      value: 'value',
      width: '300px',
      sortable: false,
      align: 'center',
    },
  ];

  money: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '$ ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  };

  percent: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '% ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  };

  moneyKey: number = 0;

  percentKey: number = 0;

  getDisplayValue(item: FeeDiscount): string {
    const value: any = item.getValue();
    return typeof value === 'number' ? value.toFixed(2) : value;
  }

  emitSelection(value: boolean, index: number): void {
    this.$emit('update:selection', { value, index });
  }

  emitValueUpdated(value: string, index: number): void {
    this.$emit('update:value', { value, index });
  }

  emitChangeValue(value: string): void {
    this.$emit('change:value', value);
  }

  getPercentRules(): Function[] {
    if (this.disabled) return [];
    if (this.limitMaximumPercent) {
      return this.validationRules.betweenZeroAndOneHundred;
    }
    return this.validationRules.greaterThanZero;
  }

  rerenderTextFields(): void {
    this.moneyKey += 1;
    this.percentKey += 1;
  }
}
